export const setMenuPositions = (node) => {
  // Calculate absolute position of dropdown menu
  let rect = node.getBoundingClientRect();
  let computedStyle = global.window.getComputedStyle(node);
  let marginBottom = parseInt(computedStyle.marginBottom, 10) || 0;
  let marginLeft = parseInt(computedStyle.marginLeft, 10) || 0;
  let marginRight = parseInt(computedStyle.marginRight, 10) || 0;
  let paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
  let paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;

  return {
    menuTop: rect.bottom + marginBottom,
    menuLeft: rect.left + marginLeft,
    menuWidth: rect.width + marginLeft + marginRight,
    inputHeight: rect.height + paddingTop + paddingBottom
  };
};

export const calcDropdownPosition = (settings) => {
  let top = settings.top;
  const extraItemsHeight = settings.itemHeight * settings.numOfExtraItems;
  const spaceAbove = top - settings.inputHeight;
  const spaceBelow = window.innerHeight - top;

  // Calculate the menu height, use the max height if items is more than can fit on one page
  let menuHeight = settings.numOfItems > settings.maxItemsPerPage - settings.numOfExtraItems ? 
    settings.itemHeight * settings.maxItemsPerPage : 
    (settings.numOfItems * settings.itemHeight) + extraItemsHeight;

  // If there's not enough room to fit the full menu below, make adjustments
  if (spaceBelow < menuHeight) { 
    // Render above the component if there's enough space
    if (spaceAbove > menuHeight) {
      top = top - menuHeight - settings.inputHeight;
    }
    // If there's not enough space above but more space below, resize the menu
    else if (spaceBelow > spaceAbove) {
      menuHeight = window.innerHeight - top;
    }
    // If there's more space above, resize the menu and display it above
    else {
      menuHeight = top - settings.inputHeight;
      top = top - menuHeight - settings.inputHeight;
    }
  }

  return {
    top: top,
    menuHeight: menuHeight
  };
};


// WEBPACK FOOTER //
// ./src/utils/CwDropdownService.js